/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HttpstwittercomyourhandleInputs */

const en_httpstwittercomyourhandle = /** @type {(inputs: HttpstwittercomyourhandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://twitter.com/yourhandle`)
};

const de_httpstwittercomyourhandle = /** @type {(inputs: HttpstwittercomyourhandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://twitter.com/yourhandle`)
};

/**
* | output |
* | --- |
* | "https://twitter.com/yourhandle" |
*
* @param {HttpstwittercomyourhandleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const httpstwittercomyourhandle = /** @type {((inputs?: HttpstwittercomyourhandleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HttpstwittercomyourhandleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_httpstwittercomyourhandle(inputs)
	return de_httpstwittercomyourhandle(inputs)
});